var exports = {
  "id": "xa15a2ab7--5401a8--discount",
  "_R": "xa15a2ab7--5401a8--original-price",
  "ip": "xa15a2ab7--5401a8--discount-percent",
};

module.exports = exports;
